import React from "react";

const SelectChip = ({ label, onRemove, colorClass }) => {
  return (
    <span className={`selected-chip ${colorClass}`}>
      <span className="chip-label" style={{ cursor: "default" }}>
        {label}
      </span>
      <button
        className="chip-remove"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        ✕
      </button>
    </span>
  );
};

export default SelectChip;

//        <SelectChip label={brandLabel(id)} onRemove={() => removeBrandChip(id)} colorClass={"brand"}/>
